import http from './http'

export default {
    get : function(id){
        return http.get(`./includes/php/ajax_load.php?tipo=cliente&codCliente=${id}`);
    },

    getAll : function(){
        return http.post('./includes/php/ajax_load.php', {
           data: {
              tipo : 'clientes'
           }
        })
    },

    create : function(client){
        client["cadastrar-cliente"] = true;
        return http.post('./includes/php/ajax_insert.php', {
            data: client
        })
    },
    update : function(client){
        client["atualizar-cliente"] = true;
        return http.post('./includes/php/ajax_update.php', {
            data: client
        })
    },

    remove : function(_id){
        return http.post('./includes/php/ajax_delete.php', {
            "deletar-cliente": true,
            id: _id
        })
    }
}


// WEBPACK FOOTER //
// ./src/js/services/clients.js